export type birthday = {
    _id: string;
    sub: string;
    name: string;
    surname: string;
    email: string;
    tel: string;
    birthDate: Date;
    daysUntilBirthday: number;
    age: number;
    natoil: string;
}
export const emptyBirthday = (): birthday => ({
    _id: undefined, // new ObjectID().toHexString(),
    sub: '',
    name: '',
    surname: '',
    email: '',
    tel: '',
    birthDate: undefined,
    daysUntilBirthday: 0,
    age: 0,
    natoil: '',
});